import { mapState } from 'vuex';
export default {
  name: 'CustomFieldsDisplayField',
  props: {
    label: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: [String, Number, Boolean],
      required: false,
      default: ''
    },
    type: {
      type: String,
      required: false,
      default: ''
    },
    showLastDigitOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    icon: {
      type: String,
      required: false,
      default: ''
    },
    iconColor: {
      type: String,
      required: false,
      default: null
    },
    iconType: {
      type: String,
      required: false,
      default: 'fal'
    },
    link: {
      type: String,
      required: false,
      default: ''
    },
    itemImage: {
      type: String,
      required: false,
      default: ''
    },
    copy: {
      type: Boolean,
      required: false,
      default: false
    },
    redirect: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapState('app', ['image', 'color', 'UiTheme']),
    getValue() {
      if (this.showLastDigitOnly) {
        let count = 4;
        return new Array(this.value.length - count + 1).join('*') + this.value.slice(-count);
      } else {
        return this.value;
      }
    }
  },
  methods: {
    copyToClipboard(event, data) {
      let value = '';
      if (typeof data === 'object' && data !== null) {
        value = JSON.stringify(data);
      } else if (typeof data === 'string') {
        value = data;
      }
      event.stopPropagation();
      // create textarea to copy from
      const copyElement = document.createElement('textarea');
      copyElement.value = value;
      // set styles to hide textarea from viewport
      copyElement.style.position = 'absolute';
      copyElement.style.top = '-99999px';
      // add to element to body otherwise we can't select/copy
      document.body.appendChild(copyElement);
      // copy text
      copyElement.select();
      document.execCommand('copy');
      // remove element
      copyElement.remove();
    }
  }
};